<template>
</template>
<script>
    import { store } from '../store/index'
    import router from '../router/index'
    export default {
        name: 'logout',
        mounted () {
            localStorage.removeItem('token')
            localStorage.removeItem('credentials')
            store.commit('LOGOUT_USER')
            router.push('/login')
        }
    }
</script>


// WEBPACK FOOTER //
// Logout.vue?924f0fde